export default __webpack_public_path__ + "static/media/cv151-2.65259a1a.png";